/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Recovery_All_ReadyInputs */

const en_us2_native_release_widget_recovery_all_ready = /** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All recovered`)
};

const pt_br2_native_release_widget_recovery_all_ready = /** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo recuperado`)
};

const pt_pt2_native_release_widget_recovery_all_ready = /** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo recuperado`)
};

/** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */
const es_419_native_release_widget_recovery_all_ready = en_us2_native_release_widget_recovery_all_ready;

/** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */
const fr_fr2_native_release_widget_recovery_all_ready = en_us2_native_release_widget_recovery_all_ready;

/** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */
const de_de2_native_release_widget_recovery_all_ready = en_us2_native_release_widget_recovery_all_ready;

/** @type {(inputs: Native_Release_Widget_Recovery_All_ReadyInputs) => LocalizedString} */
const it_it2_native_release_widget_recovery_all_ready = en_us2_native_release_widget_recovery_all_ready;

/**
* | output |
* | --- |
* | "All recovered" |
*
* @param {Native_Release_Widget_Recovery_All_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_recovery_all_ready = /** @type {((inputs?: Native_Release_Widget_Recovery_All_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Recovery_All_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_recovery_all_ready(inputs)
	if (locale === "es-419") return es_419_native_release_widget_recovery_all_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_recovery_all_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_recovery_all_ready(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_recovery_all_ready(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_recovery_all_ready(inputs)
	return en_us2_native_release_widget_recovery_all_ready(inputs)
});
export { native_release_widget_recovery_all_ready as "native-release.widget_recovery_all_ready" }